import { render, staticRenderFns } from "./TopPerformedIbTableFilter.vue?vue&type=template&id=0741666c"
import script from "./TopPerformedIbTableFilter.vue?vue&type=script&lang=js"
export * from "./TopPerformedIbTableFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports